export default __webpack_public_path__ + "static/media/hand-with-chocolate@3x.0681847e.png";